import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { SearchField, Typography, Box } from '../../../ui/core';
import PersonIcon from '../../../ui/icons/PersonIcon';
import { searchUsers } from '../../../redux/Search/action';
import { searchBarInputSx, floatSurfaceSx, softFill } from '../../../ui/styles';

const style = {
  item: {
    padding: '0 !important',
    a: {
      padding: '12px 18px',
    },
    '&:hover': { backgroundColor: softFill },
  },
};

const barPaperProps = { paper: { sx: { ...floatSurfaceSx, mt: '8px' } } };

const UsersSearch = ({ width = 500, autoFocus = false, placeholder = 'Search', variant }) => {
  const [inputValue, setInputValue] = useState('');
  // Control `open` so the results dropdown stays open while the query is
  // in-flight (debounced 500ms) and reliably shows options once they arrive —
  // an uncontrolled Autocomplete closes on the empty first render and never
  // reopens for async results.
  const [open, setOpen] = useState(false);
  const { data: users, loading } = useSelector((state) => state.search.users);
  const dispatch = useDispatch();
  const bar = variant === 'bar';

  useEffect(() => {
    const timer = setTimeout(() => {
      searchUsers({ q: inputValue })(dispatch);
    }, 500);
    return () => clearTimeout(timer);
  }, [inputValue, dispatch]);

  return (
    <SearchField
      id="users_search"
      sx={{ width }}
      autoFocus={autoFocus}
      placeholder={placeholder}
      inputSx={bar ? searchBarInputSx : undefined}
      hideStartIcon={bar}
      componentsProps={bar ? barPaperProps : undefined}
      value={null}
      inputValue={inputValue}
      options={users}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      getOptionLabel={(user) => user.id}
      onInputChange={(event, newInputValue, reason) => {
        setInputValue(newInputValue);
        if (reason === 'input') setOpen(true);
      }}
      onChange={() => setInputValue(inputValue)}
      renderOption={(props, user) => (
        <Box component="li" key={user.id} {...props} sx={style.item}>
          <Link to={`/users/${user.id}`}>
            <PersonIcon sx={{ fontSize: 14 }} />
            <Typography component="span" sx={{ marginLeft: '10px' }}>
              {user.email}
            </Typography>
            <Typography component="span" color="text.secondary" sx={{ marginLeft: '8px' }}>
              {user.firstName} {user.lastName}
            </Typography>
          </Link>
        </Box>
      )}
      blurOnSelect
      loading={loading}
    />
  );
};

export default UsersSearch;
